// import upperFirst from 'lodash/upperFirst'
// import camelCase from 'lodash/camelCase'
// const importComponent = require.context(
//   '@components',
//   true,
//   /^.*\.vue$/
// )
// const componentList = {}
// importComponent.keys().forEach(filepath => {
//   const componentKey = upperFirst(
//     camelCase(
//       filepath
//         .replace(/\.\w+$/, '')
//     )
//   )
//   componentList[componentKey] = () => import(`${filepath}`)
//   
// })


export default {
  section_header: () => import(/* webpackChunkName: "section_header" */ "@components/header/Header"),
  section_footer: () => import(/* webpackChunkName: "section_footer" */ "@components/footer/Footer"),
  section_not_exist: () => import(/* webpackChunkName: "section_not_exist" */ "@components/NotExist"),
};